import React from 'react';
import PcgsCacheManager from '../../features/admin/PcgsCacheManager';

const PcgsCacheManagerPage = () => {
  return (
    <div className="h-full">
      <PcgsCacheManager />
    </div>
  );
};

export default PcgsCacheManagerPage;
